module.exports = __webpack_public_path__ + "static/media/oedipoda_caerulescens_001_APA.34ba3584.mp3";